function initializeMinCartQuantityError() {
	const minCartQuantityErrorWrapper = document.querySelector('.min-cart-quantity-error');
	const cartDrawerContentOverlay = document.querySelector('.cart-drawer__content-overlay');
	const minCartQuantityCloseButton = document.querySelectorAll('.js-min-cart-quantity-close-button');

		if (minCartQuantityCloseButton) {
			minCartQuantityCloseButton.forEach(button => {
				button.addEventListener('click', function () {
					minCartQuantityErrorWrapper.style.display = 'none';
					cartDrawerContentOverlay.style.display = 'none';
				});
			});
		} 

		const checkoutButton = document.querySelector('.min-cart-quantity-error-checkout-button');
		if (checkoutButton) {
			const overlayInitEl = document.querySelector('.cart-drawer__content-overlay');
			if (overlayInitEl) {
				overlayInitEl.style.display = 'block';
			}
			checkoutButton.addEventListener('click', function () {
				minCartQuantityErrorWrapper.style.display = 'block';
				cartDrawerContentOverlay.style.display = 'block';
			});
		} 
}

['DOMContentLoaded', 'rerenderCart', 'cartDrawerOpened', 'minCartQuantityError'].forEach(event => {
	document.addEventListener(event, initializeMinCartQuantityError);
});



setTimeout(() => {
	initializeMinCartQuantityError();
}, 1000);
